var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchGallery)?_c('vue-picture-swipe',{staticClass:"item-thumbnail",attrs:{"items":_vm.fetchGallery}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }